import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Formulario  } from './formulario.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentesService } from '../componentes.service';
import { Inputtext, Checkbox } from './componentes';
import { AutocompleteModule } from '../autocomplete';
import { FechaModule } from '../fecha';
import { SelectormesModule } from '../selectormes';
import { UtilsModule } from '@tres-erres/ngx-utils';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
	declarations: [
		Formulario,
		Inputtext,
		Checkbox,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSnackBarModule,
		MatIconModule,
		MatTooltipModule,
		MatRadioModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		AutocompleteModule,
		FechaModule,
		SelectormesModule,
		UtilsModule,
		DirectivesModule
	],
	exports: [
		Formulario,
		Inputtext,
		Checkbox
	]
})
export class FormularioModule { }
